import { render, staticRenderFns } from "./action-ribbon.vue?vue&type=template&id=29c3c976&scoped=true&"
import script from "./action-ribbon.vue?vue&type=script&lang=js&"
export * from "./action-ribbon.vue?vue&type=script&lang=js&"
import style0 from "./action-ribbon.vue?vue&type=style&index=0&id=29c3c976&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3c976",
  null
  
)

export default component.exports